import { render, staticRenderFns } from "./HA_property.vue?vue&type=template&id=dd22923a&scoped=true"
import script from "./HA_property.vue?vue&type=script&lang=js"
export * from "./HA_property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd22923a",
  null
  
)

export default component.exports